<template>

    <div v-for="flag of data">

        <img class="mr-4 hover:ring-2 rounded-full cursor-pointer ring-offset-1 h-[20px] w-[20px]"
            style=""
            alt="Flag"
            width="20"
            height="20"
            @click="$parent.$emit('flag_clicked', flag.link)"
            :src="`/images/flag-${ flag.language }.png`"
            :title="!!flag.title ? flag.title : ''"
        />

    </div>

</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({

    name: "FlagLinks",

    props: {

        data: {
            type: Array,
            default: () => {
                return [
                    {
                        language: 'da',
                        link: 'https://hej.dk'
                    },
                    {
                        language: 'en',
                        link: 'https://hej.com'
                    }
                ];
            }
        }

    }

});
</script>

<style scoped>

</style>
